import { render, staticRenderFns } from "./ShowTree.vue?vue&type=template&id=4c5cb90c&scoped=true"
import script from "./ShowTree.vue?vue&type=script&lang=js"
export * from "./ShowTree.vue?vue&type=script&lang=js"
import style0 from "./ShowTree.vue?vue&type=style&index=0&id=4c5cb90c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5cb90c",
  null
  
)

export default component.exports